// Nova's playout: the program that plays On air (apps/playout, Rust), and the windows
// and engine that control it. One contract for all three languages (owner, 2026-11-02):
// Rust reads it with prost (compiled by protox, no protoc needed), the windows with
// protobuf-es (apps/desktop/src/core/gen), Python when it needs it.
//
// Carried over one WebSocket (ws://127.0.0.1:<port>/?token=<token>), one binary frame per
// message: a window sends Command, the playout program sends Event.
//
// Rules for changing it: never reuse or renumber a field; add new ones with new numbers.
// Older windows ignore fields they do not know, so a newer playout keeps working with them.

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts"
// @generated from file nova/playout/v1/playout.proto (package nova.playout.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file nova/playout/v1/playout.proto.
 */
export const file_nova_playout_v1_playout: GenFile = /*@__PURE__*/
  fileDesc("Ch1ub3ZhL3BsYXlvdXQvdjEvcGxheW91dC5wcm90bxIPbm92YS5wbGF5b3V0LnYxIt4CCgVUcmFjaxIKCgJpZBgBIAEoCRINCgV0aXRsZRgCIAEoCRIOCgZhcnRpc3QYAyABKAkSEAoIZHVyYXRpb24YBCABKAESEwoGY3VlX2luGAUgASgBSACIAQESFAoHY3VlX291dBgGIAEoAUgBiAEBEhMKBm1peF9hdBgHIAEoAUgCiAEBEhEKBGx1ZnMYCCABKAFIA4gBARIRCgRwZWFrGAkgASgBSASIAQESDQoFYWxidW0YCiABKAkSEQoEeWVhchgLIAEoBUgFiAEBEhAKA2JwbRgMIAEoAUgGiAEBEhMKC211c2ljYWxfa2V5GA0gASgJEhYKCWludHJvX2VuZBgOIAEoAUgHiAEBQgkKB19jdWVfaW5CCgoIX2N1ZV9vdXRCCQoHX21peF9hdEIHCgVfbHVmc0IHCgVfcGVha0IHCgVfeWVhckIGCgRfYnBtQgwKCl9pbnRyb19lbmQiXwoHT3ZlcmxheRIlCgV0cmFjaxgBIAEoCzIWLm5vdmEucGxheW91dC52MS5UcmFjaxIKCgJhdBgCIAEoARIOCgZyZWFzb24YAyABKAkSEQoJcGxhY2VtZW50GAQgASgJIvYBCgRJdGVtEgsKA2tleRgBIAEoCRIlCgV0cmFjaxgCIAEoCzIWLm5vdmEucGxheW91dC52MS5UcmFjaxIMCgRob2xkGAMgASgIEhUKCGZhZGVfb3V0GAQgASgBSACIAQESKgoIb3ZlcmxheXMYBSADKAsyGC5ub3ZhLnBsYXlvdXQudjEuT3ZlcmxheRIOCgZyZWFzb24YBiABKAkSDAoEYXV0bxgHIAEoCBIOCgZwaW5uZWQYCCABKAgSDAoEZnJvbRgJIAEoCRIUCgd0cmltbWVkGAogASgBSAGIAQFCCwoJX2ZhZGVfb3V0QgoKCF90cmltbWVkIp8PCgdDb21tYW5kEgoKAmlkGAEgASgEEi4KCXNldF9xdWV1ZRgCIAEoCzIZLm5vdmEucGxheW91dC52MS5TZXRRdWV1ZUgAEiUKBHBsYXkYAyABKAsyFS5ub3ZhLnBsYXlvdXQudjEuUGxheUgAEicKBXBhdXNlGAQgASgLMhYubm92YS5wbGF5b3V0LnYxLlBhdXNlSAASJQoEc3RvcBgFIAEoCzIVLm5vdmEucGxheW91dC52MS5TdG9wSAASJQoEbmV4dBgGIAEoCzIVLm5vdmEucGxheW91dC52MS5OZXh0SAASJQoEanVtcBgHIAEoCzIVLm5vdmEucGxheW91dC52MS5KdW1wSAASJQoEc2VlaxgIIAEoCzIVLm5vdmEucGxheW91dC52MS5TZWVrSAASMAoKc2V0X3ZvbHVtZRgJIAEoCzIaLm5vdmEucGxheW91dC52MS5TZXRWb2x1bWVIABI2Cg1zZXRfY3Jvc3NmYWRlGAogASgLMh0ubm92YS5wbGF5b3V0LnYxLlNldENyb3NzZmFkZUgAEjYKDXNldF9sZXZlbGxpbmcYCyABKAsyHS5ub3ZhLnBsYXlvdXQudjEuU2V0TGV2ZWxsaW5nSAASOAoOc2V0X2F1dG9tYXRpb24YDCABKAsyHi5ub3ZhLnBsYXlvdXQudjEuU2V0QXV0b21hdGlvbkgAEjAKCnNldF9vdXRwdXQYDSABKAsyGi5ub3ZhLnBsYXlvdXQudjEuU2V0T3V0cHV0SAASNAoMbGlzdF9vdXRwdXRzGA4gASgLMhwubm92YS5wbGF5b3V0LnYxLkxpc3RPdXRwdXRzSAASKQoGaW5zZXJ0GA8gASgLMhcubm92YS5wbGF5b3V0LnYxLkluc2VydEgAEikKBnJlbW92ZRgQIAEoCzIXLm5vdmEucGxheW91dC52MS5SZW1vdmVIABIlCgRtb3ZlGBEgASgLMhUubm92YS5wbGF5b3V0LnYxLk1vdmVIABIrCgdhcnJhbmdlGBIgASgLMhgubm92YS5wbGF5b3V0LnYxLkFycmFuZ2VIABIuCglzZXRfZmxhZ3MYEyABKAsyGS5ub3ZhLnBsYXlvdXQudjEuU2V0RmxhZ3NIABIyCgthZGRfb3ZlcmxheRgUIAEoCzIbLm5vdmEucGxheW91dC52MS5BZGRPdmVybGF5SAASJwoFY2xlYXIYFSABKAsyFi5ub3ZhLnBsYXlvdXQudjEuQ2xlYXJIABI4Cg5zZXRfdW5wbGF5YWJsZRgWIAEoCzIeLm5vdmEucGxheW91dC52MS5TZXRVbnBsYXlhYmxlSAASLgoJZmlyZV9jYXJ0GBcgASgLMhkubm92YS5wbGF5b3V0LnYxLkZpcmVDYXJ0SAASLgoJc3RvcF9jYXJ0GBggASgLMhkubm92YS5wbGF5b3V0LnYxLlN0b3BDYXJ0SAASMgoLdXBkYXRlX2NhcnQYGSABKAsyGy5ub3ZhLnBsYXlvdXQudjEuVXBkYXRlQ2FydEgAEiMKA2RpcBgaIAEoCzIULm5vdmEucGxheW91dC52MS5EaXBIABIlCgRkdWNrGBsgASgLMhUubm92YS5wbGF5b3V0LnYxLkR1Y2tIABIqCgdzZXRfbWljGBwgASgLMhcubm92YS5wbGF5b3V0LnYxLlNldE1pY0gAEiwKCG1pY19saXZlGB0gASgLMhgubm92YS5wbGF5b3V0LnYxLk1pY0xpdmVIABIyCgtsaXN0X2lucHV0cxgeIAEoCzIbLm5vdmEucGxheW91dC52MS5MaXN0SW5wdXRzSAASRwoWc2V0X3N0YXRpb25fYXV0b21hdGlvbhgfIAEoCzIlLm5vdmEucGxheW91dC52MS5TZXRTdGF0aW9uQXV0b21hdGlvbkgAEjEKC3NldF9hdXRvX2RqGCAgASgLMhoubm92YS5wbGF5b3V0LnYxLlNldEF1dG9EakgAEjAKCnNldF9mb2xsb3cYISABKAsyGi5ub3ZhLnBsYXlvdXQudjEuU2V0Rm9sbG93SAASPwoSc3RhcnRfZnJvbV9zaWxlbmNlGCIgASgLMiEubm92YS5wbGF5b3V0LnYxLlN0YXJ0RnJvbVNpbGVuY2VIABIpCgZyZXBsYW4YIyABKAsyFy5ub3ZhLnBsYXlvdXQudjEuUmVwbGFuSAASMAoKcnRjX2NvbmZpZxgkIAEoCzIaLm5vdmEucGxheW91dC52MS5SdGNDb25maWdIABIuCglydGNfb2ZmZXIYJSABKAsyGS5ub3ZhLnBsYXlvdXQudjEuUnRjT2ZmZXJIABIqCgdydGNfaWNlGCYgASgLMhcubm92YS5wbGF5b3V0LnYxLlJ0Y0ljZUgAEjAKCnJ0Y19oYW5ndXAYJyABKAsyGi5ub3ZhLnBsYXlvdXQudjEuUnRjSGFuZ3VwSAASNgoNc2V0X3ByZXNlbnRlchgoIAEoCzIdLm5vdmEucGxheW91dC52MS5TZXRQcmVzZW50ZXJIABIwCgpzZXRfc3R1ZGlvGCkgASgLMhoubm92YS5wbGF5b3V0LnYxLlNldFN0dWRpb0gAQgUKA2NtZCIwCghTZXRRdWV1ZRIkCgVpdGVtcxgBIAMoCzIVLm5vdmEucGxheW91dC52MS5JdGVtIgYKBFBsYXkiBwoFUGF1c2UiKAoEU3RvcBIUCgdzZWNvbmRzGAEgASgBSACIAQFCCgoIX3NlY29uZHMiNgoETmV4dBIMCgRmYWRlGAEgASgIEhQKB3NlY29uZHMYAiABKAFIAIgBAUIKCghfc2Vjb25kcyJdCgRKdW1wEg0KBWluZGV4GAEgASgFEg8KAmF0GAIgASgBSACIAQESDAoEZmFkZRgDIAEoCBIUCgdzZWNvbmRzGAQgASgBSAGIAQFCBQoDX2F0QgoKCF9zZWNvbmRzIhcKBFNlZWsSDwoHc2Vjb25kcxgBIAEoASIbCglTZXRWb2x1bWUSDgoGdm9sdW1lGAEgASgBIh8KDFNldENyb3NzZmFkZRIPCgdzZWNvbmRzGAEgASgBIhoKDFNldExldmVsbGluZxIKCgJvbhgBIAEoCCIbCg1TZXRBdXRvbWF0aW9uEgoKAm9uGAEgASgIIhcKCVNldE91dHB1dBIKCgJpZBgBIAEoCSINCgtMaXN0T3V0cHV0cyJjCgZJbnNlcnQSEgoFaW5kZXgYASABKAVIAIgBARIkCgVpdGVtcxgCIAMoCzIVLm5vdmEucGxheW91dC52MS5JdGVtEhUKDXN0YXJ0X2lmX2lkbGUYAyABKAhCCAoGX2luZGV4IhYKBlJlbW92ZRIMCgRrZXlzGAEgAygJIiAKBE1vdmUSDAoEZnJvbRgBIAEoBRIKCgJ0bxgCIAEoBSJNCgxBcnJhbmdlRW50cnkSDQoDa2V5GAEgASgJSAASJQoEaXRlbRgCIAEoCzIVLm5vdmEucGxheW91dC52MS5JdGVtSABCBwoFZW50cnkiNwoHQXJyYW5nZRIsCgVvcmRlchgBIAMoCzIdLm5vdmEucGxheW91dC52MS5BcnJhbmdlRW50cnkiUwoIU2V0RmxhZ3MSCwoDa2V5GAEgASgJEhEKBGhvbGQYAiABKAhIAIgBARITCgZwaW5uZWQYAyABKAhIAYgBAUIHCgVfaG9sZEIJCgdfcGlubmVkIk8KCkFkZE92ZXJsYXkSJQoFdHJhY2sYASABKAsyFi5ub3ZhLnBsYXlvdXQudjEuVHJhY2sSCgoCYXQYAiABKAESDgoGcmVhc29uGAMgASgJIgcKBUNsZWFyIi8KDVNldFVucGxheWFibGUSEQoJdHJhY2tfaWRzGAEgAygJEgsKA3doeRgCIAEoCSKVAQoNQ2FydEJlaGF2aW91chIMCgRsb29wGAEgASgIEisKBm90aGVycxgCIAEoDjIbLm5vdmEucGxheW91dC52MS5DYXJ0T3RoZXJzEikKBW11c2ljGAMgASgOMhoubm92YS5wbGF5b3V0LnYxLkNhcnRNdXNpYxITCgZkaXBfZGIYBCABKAFIAIgBAUIJCgdfZGlwX2RiInEKCEZpcmVDYXJ0EgsKA2tleRgBIAEoCRIlCgV0cmFjaxgCIAEoCzIWLm5vdmEucGxheW91dC52MS5UcmFjaxIxCgliZWhhdmlvdXIYAyABKAsyHi5ub3ZhLnBsYXlvdXQudjEuQ2FydEJlaGF2aW91ciIXCghTdG9wQ2FydBILCgNrZXkYASABKAkiTAoKVXBkYXRlQ2FydBILCgNrZXkYASABKAkSMQoJYmVoYXZpb3VyGAIgASgLMh4ubm92YS5wbGF5b3V0LnYxLkNhcnRCZWhhdmlvdXIiTwoDRGlwEg4KBnNvdXJjZRgBIAEoCRIPCgJkYhgCIAEoAUgAiAEBEhQKB3NlY29uZHMYAyABKAFIAYgBAUIFCgNfZGJCCgoIX3NlY29uZHMiEgoERHVjaxIKCgJvbhgBIAEoCCIpCgZTZXRNaWMSDwoHZW5hYmxlZBgBIAEoCBIOCgZkZXZpY2UYAiABKAkiFQoHTWljTGl2ZRIKCgJvbhgBIAEoCCIMCgpMaXN0SW5wdXRzIiIKFFNldFN0YXRpb25BdXRvbWF0aW9uEgoKAm9uGAEgASgIIhcKCVNldEF1dG9EahIKCgJvbhgBIAEoCCIbCglTZXRGb2xsb3cSDgoGZm9sbG93GAEgASgJIhIKEFN0YXJ0RnJvbVNpbGVuY2UiCAoGUmVwbGFuIj8KCUljZVNlcnZlchIMCgR1cmxzGAEgAygJEhAKCHVzZXJuYW1lGAIgASgJEhIKCmNyZWRlbnRpYWwYAyABKAkiPAoJUnRjQ29uZmlnEi8KC2ljZV9zZXJ2ZXJzGAEgAygLMhoubm92YS5wbGF5b3V0LnYxLkljZVNlcnZlciIzCghSdGNPZmZlchIMCgRwZWVyGAEgASgJEgwKBG5hbWUYAiABKAkSCwoDc2RwGAMgASgJIikKBlJ0Y0ljZRIMCgRwZWVyGAEgASgJEhEKCWNhbmRpZGF0ZRgCIAEoCSIpCglSdGNIYW5ndXASDAoEcGVlchgBIAEoCRIOCgZyZWFzb24YAiABKAkinAEKDFNldFByZXNlbnRlchIMCgRwZWVyGAEgASgJEhIKBW11dGVkGAIgASgISACIAQESFQoIdGFsa2JhY2sYAyABKAhIAYgBARIUCgdkdWNraW5nGAQgASgISAKIAQESEQoEZ2FpbhgFIAEoAUgDiAEBQggKBl9tdXRlZEILCglfdGFsa2JhY2tCCgoIX2R1Y2tpbmdCBwoFX2dhaW4iLQoJU2V0U3R1ZGlvEhQKB2R1Y2tfbXMYASABKAFIAIgBAUIKCghfZHVja19tcyL7BAoFRXZlbnQSJwoFc3RhdGUYASABKAsyFi5ub3ZhLnBsYXlvdXQudjEuU3RhdGVIABInCgVtZXRlchgCIAEoCzIWLm5vdmEucGxheW91dC52MS5NZXRlckgAEicKBXJlcGx5GAMgASgLMhYubm92YS5wbGF5b3V0LnYxLlJlcGx5SAASKwoHb3V0cHV0cxgEIAEoCzIYLm5vdmEucGxheW91dC52MS5PdXRwdXRzSAASKwoHc3RhcnRlZBgFIAEoCzIYLm5vdmEucGxheW91dC52MS5TdGFydGVkSAASJwoFcXVldWUYBiABKAsyFi5ub3ZhLnBsYXlvdXQudjEuUXVldWVIABIpCgZwbGF5ZWQYByABKAsyFy5ub3ZhLnBsYXlvdXQudjEuUGxheWVkSAASKwoHc2tpcHBlZBgIIAEoCzIYLm5vdmEucGxheW91dC52MS5Ta2lwcGVkSAASKQoGaW5wdXRzGAkgASgLMhcubm92YS5wbGF5b3V0LnYxLklucHV0c0gAEisKB3N0YXRpb24YCiABKAsyGC5ub3ZhLnBsYXlvdXQudjEuU3RhdGlvbkgAEikKBm5vdGljZRgLIAEoCzIXLm5vdmEucGxheW91dC52MS5Ob3RpY2VIABIrCgd0cmltbWVkGAwgASgLMhgubm92YS5wbGF5b3V0LnYxLlRyaW1tZWRIABIwCgpydGNfc2lnbmFsGA0gASgLMhoubm92YS5wbGF5b3V0LnYxLlJ0Y1NpZ25hbEgAEjEKCnByZXNlbnRlcnMYDiABKAsyGy5ub3ZhLnBsYXlvdXQudjEuUHJlc2VudGVyc0gAQgcKBWV2ZW50IlcKCVJ0Y1NpZ25hbBIMCgRwZWVyGAEgASgJEgwKBGtpbmQYAiABKAkSCwoDc2RwGAMgASgJEhEKCWNhbmRpZGF0ZRgEIAEoCRIOCgZyZWFzb24YBSABKAkixwEKCVByZXNlbnRlchIMCgRwZWVyGAEgASgJEgwKBG5hbWUYAiABKAkSEQoJY29ubmVjdGVkGAMgASgIEgwKBGxpdmUYBCABKAgSDQoFbXV0ZWQYBSABKAgSEAoIdGFsa2JhY2sYBiABKAgSDwoHZHVja2luZxgHIAEoCBIMCgRnYWluGAggASgBEg0KBWxldmVsGAkgASgBEg8KB3NlbmRpbmcYCiABKAgSDAoEYmFjaxgLIAEoARIPCgdwcm9ibGVtGAwgASgJIjYKClByZXNlbnRlcnMSKAoEbGlzdBgBIAMoCzIaLm5vdmEucGxheW91dC52MS5QcmVzZW50ZXIihgMKBVN0YXRlEg0KBWluZGV4GAEgASgFEhMKC2N1cnJlbnRfa2V5GAIgASgJEg8KB3BsYXlpbmcYAyABKAgSEAoIcG9zaXRpb24YBCABKAESEAoIZHVyYXRpb24YBSABKAESDgoGdm9sdW1lGAYgASgBEhEKCWNyb3NzZmFkZRgHIAEoARIRCglsZXZlbGxpbmcYCCABKAgSEgoKYXV0b21hdGlvbhgJIAEoCBIOCgZvdXRwdXQYCiABKAkSDwoHbG9hZGluZxgLIAEoCBINCgVlcnJvchgMIAEoCRINCgVhdF9tcxgNIAEoBBISCgpxdWV1ZV9rZXlzGA4gAygJEhUKDXF1ZXVlX3ZlcnNpb24YDyABKAQSDgoGZHVja2VkGBAgASgIEisKBWNhcnRzGBEgAygLMhwubm92YS5wbGF5b3V0LnYxLkNhcnRQbGF5aW5nEiEKA21pYxgSIAEoCzIULm5vdmEucGxheW91dC52MS5NaWMSEAoIb3Zlcl9rZXkYEyABKAkiTgoLQ2FydFBsYXlpbmcSCwoDa2V5GAEgASgJEhAKCHRyYWNrX2lkGAIgASgJEg4KBmxlbmd0aBgDIAEoARIQCghwb3NpdGlvbhgEIAEoASJSCgNNaWMSDwoHZW5hYmxlZBgBIAEoCBIMCgRsaXZlGAIgASgIEg0KBXJlYWR5GAMgASgIEg0KBWVycm9yGAQgASgJEg4KBmRldmljZRgFIAEoCSI+CgVRdWV1ZRIPCgd2ZXJzaW9uGAEgASgEEiQKBWl0ZW1zGAIgAygLMhUubm92YS5wbGF5b3V0LnYxLkl0ZW0ifgoGUGxheWVkEhAKCHRyYWNrX2lkGAEgASgJEhIKCnN0YXJ0ZWRfbXMYAiABKAQSDwoHc2Vjb25kcxgDIAEoARIQCghmaW5pc2hlZBgEIAEoCBIOCgZzb3VyY2UYBSABKAkSDgoGcmVhc29uGAYgASgJEgsKA2tleRgHIAEoCSI3CgdTa2lwcGVkEhAKCHRyYWNrX2lkGAEgASgJEg0KBXRpdGxlGAIgASgJEgsKA3doeRgDIAEoCSJCCgZJbnB1dHMSJwoGaW5wdXRzGAEgAygLMhcubm92YS5wbGF5b3V0LnYxLk91dHB1dBIPCgdjdXJyZW50GAIgASgJIhcKB1RyaW1tZWQSDAoEa2V5cxgBIAMoCSIjCgZOb3RpY2USDAoEdGV4dBgBIAEoCRILCgNiYWQYAiABKAgigAMKB1N0YXRpb24SDwoHcnVubmluZxgBIAEoCBISCgphdXRvbWF0aW9uGAIgASgIEg8KB2F1dG9fZGoYAyABKAgSDgoGZm9sbG93GAQgASgJEi0KCXByb2dyYW1tZRgFIAEoCzIaLm5vdmEucGxheW91dC52MS5Qcm9ncmFtbWUSJwoEbGl2ZRgGIAEoCzIZLm5vdmEucGxheW91dC52MS5MaXZlU2hvdxIoCgdtYXJrZXJzGAcgAygLMhcubm92YS5wbGF5b3V0LnYxLk1hcmtlchIUCgxmYWRlX3NlY29uZHMYCCABKAESEgoKbGF0ZV9saW1pdBgJIAEoARIUCgxxdWV1ZWRfZWFybHkYCiADKAkSOwoKc3RhcnRlZF9tcxgLIAMoCzInLm5vdmEucGxheW91dC52MS5TdGF0aW9uLlN0YXJ0ZWRNc0VudHJ5GjAKDlN0YXJ0ZWRNc0VudHJ5EgsKA2tleRgBIAEoCRINCgV2YWx1ZRgCIAEoBDoCOAEiQwoJUHJvZ3JhbW1lEgwKBG5hbWUYASABKAkSDAoEa2luZBgCIAEoCRINCgVzdGFydBgDIAEoCRILCgNlbmQYBCABKAkiJQoITGl2ZVNob3cSDAoEbmFtZRgBIAEoCRILCgNlbmQYAiABKAkivgEKBk1hcmtlchIRCgltYXJrZXJfaWQYASABKAkSDAoEbmFtZRgCIAEoCRIMCgRraW5kGAMgASgJEgoKAmF0GAQgASgJEg0KBWFsaWduGAUgASgJEg0KBXN0YXJ0GAYgASgJEhwKD2NvbnRlbnRfc2Vjb25kcxgHIAEoAUgAiAEBEhQKDGNvbnRlbnRfa2luZBgIIAEoCRITCgtjb250ZW50X3JlZhgJIAEoCUISChBfY29udGVudF9zZWNvbmRzIlMKBU1ldGVyEhAKCHJtc19sZWZ0GAEgASgCEhEKCXJtc19yaWdodBgCIAEoAhIRCglwZWFrX2xlZnQYAyABKAISEgoKcGVha19yaWdodBgEIAEoAiIuCgVSZXBseRIKCgJpZBgBIAEoBBIKCgJvaxgCIAEoCBINCgVlcnJvchgDIAEoCSI2CgZPdXRwdXQSCgoCaWQYASABKAkSDAoEbmFtZRgCIAEoCRISCgppc19kZWZhdWx0GAMgASgIIkQKB091dHB1dHMSKAoHb3V0cHV0cxgBIAMoCzIXLm5vdmEucGxheW91dC52MS5PdXRwdXQSDwoHY3VycmVudBgCIAEoCSIlCgdTdGFydGVkEgsKA2tleRgBIAEoCRINCgVhdF9tcxgCIAEoBCpSCgpDYXJ0T3RoZXJzEhQKEENBUlRfT1RIRVJTX1NUT1AQABIZChVDQVJUX09USEVSU19BTE9OR1NJREUQARITCg9DQVJUX09USEVSU19ESVAQAipNCglDYXJ0TXVzaWMSEwoPQ0FSVF9NVVNJQ19PVkVSEAASEgoOQ0FSVF9NVVNJQ19ESVAQARIXChNDQVJUX01VU0lDX1RBS0VPVkVSEAJiBnByb3RvMw");

/**
 * A file to play, as the engine describes it (seconds into the file; dB / LUFS).
 *
 * @generated from message nova.playout.v1.Track
 */
export type Track = Message<"nova.playout.v1.Track"> & {
  /**
   * the engine's track id; audio is GET /api/track/audio?id=
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string artist = 3;
   */
  artist: string;

  /**
   * @generated from field: double duration = 4;
   */
  duration: number;

  /**
   * where it starts (else 0)
   *
   * @generated from field: optional double cue_in = 5;
   */
  cueIn?: number | undefined;

  /**
   * the Early Out: where it ends (else the file's end)
   *
   * @generated from field: optional double cue_out = 6;
   */
  cueOut?: number | undefined;

  /**
   * the mix point in force (core/handover.ts)
   *
   * @generated from field: optional double mix_at = 7;
   */
  mixAt?: number | undefined;

  /**
   * loudness, for levelling
   *
   * @generated from field: optional double lufs = 8;
   */
  lufs?: number | undefined;

  /**
   * loudest sample, dBFS: levelling never boosts past -1 dB under it
   *
   * @generated from field: optional double peak = 9;
   */
  peak?: number | undefined;

  /**
   * For the desks (phase B): what Up next shows and Auto DJ compares.
   *
   * @generated from field: string album = 10;
   */
  album: string;

  /**
   * @generated from field: optional int32 year = 11;
   */
  year?: number | undefined;

  /**
   * @generated from field: optional double bpm = 12;
   */
  bpm?: number | undefined;

  /**
   * @generated from field: string musical_key = 13;
   */
  musicalKey: string;

  /**
   * where the vocal comes in
   *
   * @generated from field: optional double intro_end = 14;
   */
  introEnd?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.Track.
 * Use `create(TrackSchema)` to create a new message.
 */
export const TrackSchema: GenMessage<Track> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 0);

/**
 * A clip played over a song, `at` seconds into the song's file: the song dips 12 dB under it.
 *
 * @generated from message nova.playout.v1.Overlay
 */
export type Overlay = Message<"nova.playout.v1.Overlay"> & {
  /**
   * @generated from field: nova.playout.v1.Track track = 1;
   */
  track?: Track | undefined;

  /**
   * @generated from field: double at = 2;
   */
  at: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;

  /**
   * @generated from field: string placement = 4;
   */
  placement: string;
};

/**
 * Describes the message nova.playout.v1.Overlay.
 * Use `create(OverlaySchema)` to create a new message.
 */
export const OverlaySchema: GenMessage<Overlay> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 1);

/**
 * One entry in the queue.
 *
 * @generated from message nova.playout.v1.Item
 */
export type Item = Message<"nova.playout.v1.Item"> & {
  /**
   * unique in the queue
   *
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: nova.playout.v1.Track track = 2;
   */
  track?: Track | undefined;

  /**
   * waits for Play: the item before plays to its end
   *
   * @generated from field: bool hold = 3;
   */
  hold: boolean;

  /**
   * fade out over this many seconds before its end
   *
   * @generated from field: optional double fade_out = 4;
   */
  fadeOut?: number | undefined;

  /**
   * clips over this song
   *
   * @generated from field: repeated nova.playout.v1.Overlay overlays = 5;
   */
  overlays: Overlay[];

  /**
   * why it was queued (the play log; "rule:<id>"); empty for a song
   *
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * chosen by Auto DJ: may be planned again
   *
   * @generated from field: bool auto = 7;
   */
  auto: boolean;

  /**
   * placed by hand
   *
   * @generated from field: bool pinned = 8;
   */
  pinned: boolean;

  /**
   * the show whose playlist or flow queued it
   *
   * @generated from field: string from = 9;
   */
  from: string;

  /**
   * seconds it was shortened by
   *
   * @generated from field: optional double trimmed = 10;
   */
  trimmed?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.Item.
 * Use `create(ItemSchema)` to create a new message.
 */
export const ItemSchema: GenMessage<Item> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 2);

/**
 * From a window.
 *
 * @generated from message nova.playout.v1.Command
 */
export type Command = Message<"nova.playout.v1.Command"> & {
  /**
   * echoed in the Reply
   *
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from oneof nova.playout.v1.Command.cmd
   */
  cmd: {
    /**
     * @generated from field: nova.playout.v1.SetQueue set_queue = 2;
     */
    value: SetQueue;
    case: "setQueue";
  } | {
    /**
     * @generated from field: nova.playout.v1.Play play = 3;
     */
    value: Play;
    case: "play";
  } | {
    /**
     * @generated from field: nova.playout.v1.Pause pause = 4;
     */
    value: Pause;
    case: "pause";
  } | {
    /**
     * @generated from field: nova.playout.v1.Stop stop = 5;
     */
    value: Stop;
    case: "stop";
  } | {
    /**
     * @generated from field: nova.playout.v1.Next next = 6;
     */
    value: Next;
    case: "next";
  } | {
    /**
     * @generated from field: nova.playout.v1.Jump jump = 7;
     */
    value: Jump;
    case: "jump";
  } | {
    /**
     * @generated from field: nova.playout.v1.Seek seek = 8;
     */
    value: Seek;
    case: "seek";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetVolume set_volume = 9;
     */
    value: SetVolume;
    case: "setVolume";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetCrossfade set_crossfade = 10;
     */
    value: SetCrossfade;
    case: "setCrossfade";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetLevelling set_levelling = 11;
     */
    value: SetLevelling;
    case: "setLevelling";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetAutomation set_automation = 12;
     */
    value: SetAutomation;
    case: "setAutomation";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetOutput set_output = 13;
     */
    value: SetOutput;
    case: "setOutput";
  } | {
    /**
     * @generated from field: nova.playout.v1.ListOutputs list_outputs = 14;
     */
    value: ListOutputs;
    case: "listOutputs";
  } | {
    /**
     * Phase B: the queue edited in place, clips over songs, carts, dips, the mic.
     *
     * @generated from field: nova.playout.v1.Insert insert = 15;
     */
    value: Insert;
    case: "insert";
  } | {
    /**
     * @generated from field: nova.playout.v1.Remove remove = 16;
     */
    value: Remove;
    case: "remove";
  } | {
    /**
     * @generated from field: nova.playout.v1.Move move = 17;
     */
    value: Move;
    case: "move";
  } | {
    /**
     * @generated from field: nova.playout.v1.Arrange arrange = 18;
     */
    value: Arrange;
    case: "arrange";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetFlags set_flags = 19;
     */
    value: SetFlags;
    case: "setFlags";
  } | {
    /**
     * @generated from field: nova.playout.v1.AddOverlay add_overlay = 20;
     */
    value: AddOverlay;
    case: "addOverlay";
  } | {
    /**
     * @generated from field: nova.playout.v1.Clear clear = 21;
     */
    value: Clear;
    case: "clear";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetUnplayable set_unplayable = 22;
     */
    value: SetUnplayable;
    case: "setUnplayable";
  } | {
    /**
     * @generated from field: nova.playout.v1.FireCart fire_cart = 23;
     */
    value: FireCart;
    case: "fireCart";
  } | {
    /**
     * @generated from field: nova.playout.v1.StopCart stop_cart = 24;
     */
    value: StopCart;
    case: "stopCart";
  } | {
    /**
     * @generated from field: nova.playout.v1.UpdateCart update_cart = 25;
     */
    value: UpdateCart;
    case: "updateCart";
  } | {
    /**
     * @generated from field: nova.playout.v1.Dip dip = 26;
     */
    value: Dip;
    case: "dip";
  } | {
    /**
     * @generated from field: nova.playout.v1.Duck duck = 27;
     */
    value: Duck;
    case: "duck";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetMic set_mic = 28;
     */
    value: SetMic;
    case: "setMic";
  } | {
    /**
     * @generated from field: nova.playout.v1.MicLive mic_live = 29;
     */
    value: MicLive;
    case: "micLive";
  } | {
    /**
     * @generated from field: nova.playout.v1.ListInputs list_inputs = 30;
     */
    value: ListInputs;
    case: "listInputs";
  } | {
    /**
     * Phase C: the station's brain.
     *
     * @generated from field: nova.playout.v1.SetStationAutomation set_station_automation = 31;
     */
    value: SetStationAutomation;
    case: "setStationAutomation";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetAutoDj set_auto_dj = 32;
     */
    value: SetAutoDj;
    case: "setAutoDj";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetFollow set_follow = 33;
     */
    value: SetFollow;
    case: "setFollow";
  } | {
    /**
     * @generated from field: nova.playout.v1.StartFromSilence start_from_silence = 34;
     */
    value: StartFromSilence;
    case: "startFromSilence";
  } | {
    /**
     * @generated from field: nova.playout.v1.Replan replan = 35;
     */
    value: Replan;
    case: "replan";
  } | {
    /**
     * Phase D: Remote Studio's presenters (WebRTC), signalled through the window that owns
     * On air (it relays the engine's live link both ways).
     *
     * @generated from field: nova.playout.v1.RtcConfig rtc_config = 36;
     */
    value: RtcConfig;
    case: "rtcConfig";
  } | {
    /**
     * @generated from field: nova.playout.v1.RtcOffer rtc_offer = 37;
     */
    value: RtcOffer;
    case: "rtcOffer";
  } | {
    /**
     * @generated from field: nova.playout.v1.RtcIce rtc_ice = 38;
     */
    value: RtcIce;
    case: "rtcIce";
  } | {
    /**
     * @generated from field: nova.playout.v1.RtcHangup rtc_hangup = 39;
     */
    value: RtcHangup;
    case: "rtcHangup";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetPresenter set_presenter = 40;
     */
    value: SetPresenter;
    case: "setPresenter";
  } | {
    /**
     * @generated from field: nova.playout.v1.SetStudio set_studio = 41;
     */
    value: SetStudio;
    case: "setStudio";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message nova.playout.v1.Command.
 * Use `create(CommandSchema)` to create a new message.
 */
export const CommandSchema: GenMessage<Command> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 3);

/**
 * Replace the queue. The item playing (matched by key) carries on where it is.
 *
 * @generated from message nova.playout.v1.SetQueue
 */
export type SetQueue = Message<"nova.playout.v1.SetQueue"> & {
  /**
   * @generated from field: repeated nova.playout.v1.Item items = 1;
   */
  items: Item[];
};

/**
 * Describes the message nova.playout.v1.SetQueue.
 * Use `create(SetQueueSchema)` to create a new message.
 */
export const SetQueueSchema: GenMessage<SetQueue> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 4);

/**
 * @generated from message nova.playout.v1.Play
 */
export type Play = Message<"nova.playout.v1.Play"> & {
};

/**
 * Describes the message nova.playout.v1.Play.
 * Use `create(PlaySchema)` to create a new message.
 */
export const PlaySchema: GenMessage<Play> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 5);

/**
 * @generated from message nova.playout.v1.Pause
 */
export type Pause = Message<"nova.playout.v1.Pause"> & {
};

/**
 * Describes the message nova.playout.v1.Pause.
 * Use `create(PauseSchema)` to create a new message.
 */
export const PauseSchema: GenMessage<Pause> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 6);

/**
 * Fade out over `seconds` (default 1) and make the next item ready, waiting for Play.
 *
 * @generated from message nova.playout.v1.Stop
 */
export type Stop = Message<"nova.playout.v1.Stop"> & {
  /**
   * @generated from field: optional double seconds = 1;
   */
  seconds?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.Stop.
 * Use `create(StopSchema)` to create a new message.
 */
export const StopSchema: GenMessage<Stop> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 7);

/**
 * The next item now; with `fade`, crossfaded over `seconds` (default: the crossfade).
 *
 * @generated from message nova.playout.v1.Next
 */
export type Next = Message<"nova.playout.v1.Next"> & {
  /**
   * @generated from field: bool fade = 1;
   */
  fade: boolean;

  /**
   * @generated from field: optional double seconds = 2;
   */
  seconds?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.Next.
 * Use `create(NextSchema)` to create a new message.
 */
export const NextSchema: GenMessage<Next> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 8);

/**
 * Play the item at `index`, from `at` seconds into the file (default its Cue In).
 *
 * @generated from message nova.playout.v1.Jump
 */
export type Jump = Message<"nova.playout.v1.Jump"> & {
  /**
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: optional double at = 2;
   */
  at?: number | undefined;

  /**
   * @generated from field: bool fade = 3;
   */
  fade: boolean;

  /**
   * @generated from field: optional double seconds = 4;
   */
  seconds?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.Jump.
 * Use `create(JumpSchema)` to create a new message.
 */
export const JumpSchema: GenMessage<Jump> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 9);

/**
 * @generated from message nova.playout.v1.Seek
 */
export type Seek = Message<"nova.playout.v1.Seek"> & {
  /**
   * @generated from field: double seconds = 1;
   */
  seconds: number;
};

/**
 * Describes the message nova.playout.v1.Seek.
 * Use `create(SeekSchema)` to create a new message.
 */
export const SeekSchema: GenMessage<Seek> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 10);

/**
 * @generated from message nova.playout.v1.SetVolume
 */
export type SetVolume = Message<"nova.playout.v1.SetVolume"> & {
  /**
   * 0..1
   *
   * @generated from field: double volume = 1;
   */
  volume: number;
};

/**
 * Describes the message nova.playout.v1.SetVolume.
 * Use `create(SetVolumeSchema)` to create a new message.
 */
export const SetVolumeSchema: GenMessage<SetVolume> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 11);

/**
 * @generated from message nova.playout.v1.SetCrossfade
 */
export type SetCrossfade = Message<"nova.playout.v1.SetCrossfade"> & {
  /**
   * @generated from field: double seconds = 1;
   */
  seconds: number;
};

/**
 * Describes the message nova.playout.v1.SetCrossfade.
 * Use `create(SetCrossfadeSchema)` to create a new message.
 */
export const SetCrossfadeSchema: GenMessage<SetCrossfade> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 12);

/**
 * @generated from message nova.playout.v1.SetLevelling
 */
export type SetLevelling = Message<"nova.playout.v1.SetLevelling"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message nova.playout.v1.SetLevelling.
 * Use `create(SetLevellingSchema)` to create a new message.
 */
export const SetLevellingSchema: GenMessage<SetLevelling> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 13);

/**
 * On: one item runs into the next. Off (Live Assist): each item waits for Play.
 *
 * @generated from message nova.playout.v1.SetAutomation
 */
export type SetAutomation = Message<"nova.playout.v1.SetAutomation"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message nova.playout.v1.SetAutomation.
 * Use `create(SetAutomationSchema)` to create a new message.
 */
export const SetAutomationSchema: GenMessage<SetAutomation> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 14);

/**
 * The sound card to play on: an id from Outputs, or "" for the system's own.
 *
 * @generated from message nova.playout.v1.SetOutput
 */
export type SetOutput = Message<"nova.playout.v1.SetOutput"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;
};

/**
 * Describes the message nova.playout.v1.SetOutput.
 * Use `create(SetOutputSchema)` to create a new message.
 */
export const SetOutputSchema: GenMessage<SetOutput> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 15);

/**
 * @generated from message nova.playout.v1.ListOutputs
 */
export type ListOutputs = Message<"nova.playout.v1.ListOutputs"> & {
};

/**
 * Describes the message nova.playout.v1.ListOutputs.
 * Use `create(ListOutputsSchema)` to create a new message.
 */
export const ListOutputsSchema: GenMessage<ListOutputs> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 16);

/**
 * Put items in: at `index` (absent: right after the item playing). With `start_if_idle`,
 * nothing current makes the first of the queue play (as adding to an idle player does).
 *
 * @generated from message nova.playout.v1.Insert
 */
export type Insert = Message<"nova.playout.v1.Insert"> & {
  /**
   * @generated from field: optional int32 index = 1;
   */
  index?: number | undefined;

  /**
   * @generated from field: repeated nova.playout.v1.Item items = 2;
   */
  items: Item[];

  /**
   * @generated from field: bool start_if_idle = 3;
   */
  startIfIdle: boolean;
};

/**
 * Describes the message nova.playout.v1.Insert.
 * Use `create(InsertSchema)` to create a new message.
 */
export const InsertSchema: GenMessage<Insert> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 17);

/**
 * Take out upcoming items by key (never the one playing, nor any already played).
 *
 * @generated from message nova.playout.v1.Remove
 */
export type Remove = Message<"nova.playout.v1.Remove"> & {
  /**
   * @generated from field: repeated string keys = 1;
   */
  keys: string[];
};

/**
 * Describes the message nova.playout.v1.Remove.
 * Use `create(RemoveSchema)` to create a new message.
 */
export const RemoveSchema: GenMessage<Remove> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 18);

/**
 * Move an upcoming item by hand; it is pinned where it lands.
 *
 * @generated from message nova.playout.v1.Move
 */
export type Move = Message<"nova.playout.v1.Move"> & {
  /**
   * @generated from field: int32 from = 1;
   */
  from: number;

  /**
   * @generated from field: int32 to = 2;
   */
  to: number;
};

/**
 * Describes the message nova.playout.v1.Move.
 * Use `create(MoveSchema)` to create a new message.
 */
export const MoveSchema: GenMessage<Move> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 19);

/**
 * Reorder what follows the item playing and put new ones in, as one change. Keys no
 * longer upcoming are skipped; upcoming items left out keep their order at the end.
 *
 * @generated from message nova.playout.v1.ArrangeEntry
 */
export type ArrangeEntry = Message<"nova.playout.v1.ArrangeEntry"> & {
  /**
   * @generated from oneof nova.playout.v1.ArrangeEntry.entry
   */
  entry: {
    /**
     * @generated from field: string key = 1;
     */
    value: string;
    case: "key";
  } | {
    /**
     * @generated from field: nova.playout.v1.Item item = 2;
     */
    value: Item;
    case: "item";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message nova.playout.v1.ArrangeEntry.
 * Use `create(ArrangeEntrySchema)` to create a new message.
 */
export const ArrangeEntrySchema: GenMessage<ArrangeEntry> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 20);

/**
 * @generated from message nova.playout.v1.Arrange
 */
export type Arrange = Message<"nova.playout.v1.Arrange"> & {
  /**
   * @generated from field: repeated nova.playout.v1.ArrangeEntry order = 1;
   */
  order: ArrangeEntry[];
};

/**
 * Describes the message nova.playout.v1.Arrange.
 * Use `create(ArrangeSchema)` to create a new message.
 */
export const ArrangeSchema: GenMessage<Arrange> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 21);

/**
 * Mark an upcoming item to wait for Play (`hold`), or pinned.
 *
 * @generated from message nova.playout.v1.SetFlags
 */
export type SetFlags = Message<"nova.playout.v1.SetFlags"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: optional bool hold = 2;
   */
  hold?: boolean | undefined;

  /**
   * @generated from field: optional bool pinned = 3;
   */
  pinned?: boolean | undefined;
};

/**
 * Describes the message nova.playout.v1.SetFlags.
 * Use `create(SetFlagsSchema)` to create a new message.
 */
export const SetFlagsSchema: GenMessage<SetFlags> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 22);

/**
 * Play `track` over the item playing, `at` seconds into its file (at once if past).
 *
 * @generated from message nova.playout.v1.AddOverlay
 */
export type AddOverlay = Message<"nova.playout.v1.AddOverlay"> & {
  /**
   * @generated from field: nova.playout.v1.Track track = 1;
   */
  track?: Track | undefined;

  /**
   * @generated from field: double at = 2;
   */
  at: number;

  /**
   * @generated from field: string reason = 3;
   */
  reason: string;
};

/**
 * Describes the message nova.playout.v1.AddOverlay.
 * Use `create(AddOverlaySchema)` to create a new message.
 */
export const AddOverlaySchema: GenMessage<AddOverlay> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 23);

/**
 * Empty the queue and stop.
 *
 * @generated from message nova.playout.v1.Clear
 */
export type Clear = Message<"nova.playout.v1.Clear"> & {
};

/**
 * Describes the message nova.playout.v1.Clear.
 * Use `create(ClearSchema)` to create a new message.
 */
export const ClearSchema: GenMessage<Clear> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 24);

/**
 * Songs that may not play (dirty songs): passed over for the next one that may.
 *
 * @generated from message nova.playout.v1.SetUnplayable
 */
export type SetUnplayable = Message<"nova.playout.v1.SetUnplayable"> & {
  /**
   * @generated from field: repeated string track_ids = 1;
   */
  trackIds: string[];

  /**
   * @generated from field: string why = 2;
   */
  why: string;
};

/**
 * Describes the message nova.playout.v1.SetUnplayable.
 * Use `create(SetUnplayableSchema)` to create a new message.
 */
export const SetUnplayableSchema: GenMessage<SetUnplayable> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 25);

/**
 * @generated from message nova.playout.v1.CartBehaviour
 */
export type CartBehaviour = Message<"nova.playout.v1.CartBehaviour"> & {
  /**
   * @generated from field: bool loop = 1;
   */
  loop: boolean;

  /**
   * @generated from field: nova.playout.v1.CartOthers others = 2;
   */
  others: CartOthers;

  /**
   * @generated from field: nova.playout.v1.CartMusic music = 3;
   */
  music: CartMusic;

  /**
   * default 12, kept between 3 and 30
   *
   * @generated from field: optional double dip_db = 4;
   */
  dipDb?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.CartBehaviour.
 * Use `create(CartBehaviourSchema)` to create a new message.
 */
export const CartBehaviourSchema: GenMessage<CartBehaviour> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 26);

/**
 * Fire a cart (`key` names it, "page:index"); firing one already playing stops it.
 *
 * @generated from message nova.playout.v1.FireCart
 */
export type FireCart = Message<"nova.playout.v1.FireCart"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: nova.playout.v1.Track track = 2;
   */
  track?: Track | undefined;

  /**
   * @generated from field: nova.playout.v1.CartBehaviour behaviour = 3;
   */
  behaviour?: CartBehaviour | undefined;
};

/**
 * Describes the message nova.playout.v1.FireCart.
 * Use `create(FireCartSchema)` to create a new message.
 */
export const FireCartSchema: GenMessage<FireCart> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 27);

/**
 * @generated from message nova.playout.v1.StopCart
 */
export type StopCart = Message<"nova.playout.v1.StopCart"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;
};

/**
 * Describes the message nova.playout.v1.StopCart.
 * Use `create(StopCartSchema)` to create a new message.
 */
export const StopCartSchema: GenMessage<StopCart> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 28);

/**
 * A playing cart's settings changed (the dip scale, say): applies at once.
 *
 * @generated from message nova.playout.v1.UpdateCart
 */
export type UpdateCart = Message<"nova.playout.v1.UpdateCart"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: nova.playout.v1.CartBehaviour behaviour = 2;
   */
  behaviour?: CartBehaviour | undefined;
};

/**
 * Describes the message nova.playout.v1.UpdateCart.
 * Use `create(UpdateCartSchema)` to create a new message.
 */
export const UpdateCartSchema: GenMessage<UpdateCart> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 29);

/**
 * Lower the songs by `db` for `source`, or bring them back (`db` absent). Several at
 * once: the deepest wins. Clips over a song and carts are not lowered.
 *
 * @generated from message nova.playout.v1.Dip
 */
export type Dip = Message<"nova.playout.v1.Dip"> & {
  /**
   * @generated from field: string source = 1;
   */
  source: string;

  /**
   * @generated from field: optional double db = 2;
   */
  db?: number | undefined;

  /**
   * default 0.4
   *
   * @generated from field: optional double seconds = 3;
   */
  seconds?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.Dip.
 * Use `create(DipSchema)` to create a new message.
 */
export const DipSchema: GenMessage<Dip> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 30);

/**
 * Lower everything but live voices by 12 dB (talk-over), or bring it back.
 *
 * @generated from message nova.playout.v1.Duck
 */
export type Duck = Message<"nova.playout.v1.Duck"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message nova.playout.v1.Duck.
 * Use `create(DuckSchema)` to create a new message.
 */
export const DuckSchema: GenMessage<Duck> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 31);

/**
 * The microphone at the station: on opens it (silent until MicLive), off closes it.
 *
 * @generated from message nova.playout.v1.SetMic
 */
export type SetMic = Message<"nova.playout.v1.SetMic"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * an id from Inputs; "" for the system's own
   *
   * @generated from field: string device = 2;
   */
  device: string;
};

/**
 * Describes the message nova.playout.v1.SetMic.
 * Use `create(SetMicSchema)` to create a new message.
 */
export const SetMicSchema: GenMessage<SetMic> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 32);

/**
 * Mic on air: the voice goes out past the volume and the duck; the music ducks.
 *
 * @generated from message nova.playout.v1.MicLive
 */
export type MicLive = Message<"nova.playout.v1.MicLive"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message nova.playout.v1.MicLive.
 * Use `create(MicLiveSchema)` to create a new message.
 */
export const MicLiveSchema: GenMessage<MicLive> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 33);

/**
 * @generated from message nova.playout.v1.ListInputs
 */
export type ListInputs = Message<"nova.playout.v1.ListInputs"> & {
};

/**
 * Describes the message nova.playout.v1.ListInputs.
 * Use `create(ListInputsSchema)` to create a new message.
 */
export const ListInputsSchema: GenMessage<ListInputs> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 34);

/**
 * Automation on: Auto DJ comes with it and playing starts. Off: the presenter's.
 *
 * @generated from message nova.playout.v1.SetStationAutomation
 */
export type SetStationAutomation = Message<"nova.playout.v1.SetStationAutomation"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message nova.playout.v1.SetStationAutomation.
 * Use `create(SetStationAutomationSchema)` to create a new message.
 */
export const SetStationAutomationSchema: GenMessage<SetStationAutomation> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 35);

/**
 * @generated from message nova.playout.v1.SetAutoDj
 */
export type SetAutoDj = Message<"nova.playout.v1.SetAutoDj"> & {
  /**
   * @generated from field: bool on = 1;
   */
  on: boolean;
};

/**
 * Describes the message nova.playout.v1.SetAutoDj.
 * Use `create(SetAutoDjSchema)` to create a new message.
 */
export const SetAutoDjSchema: GenMessage<SetAutoDj> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 36);

/**
 * What Auto DJ plays when no show's programme is on: "similar", or "flow:<id>".
 *
 * @generated from message nova.playout.v1.SetFollow
 */
export type SetFollow = Message<"nova.playout.v1.SetFollow"> & {
  /**
   * @generated from field: string follow = 1;
   */
  follow: string;
};

/**
 * Describes the message nova.playout.v1.SetFollow.
 * Use `create(SetFollowSchema)` to create a new message.
 */
export const SetFollowSchema: GenMessage<SetFollow> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 37);

/**
 * Nothing on air: Auto DJ plans the first songs and starts.
 *
 * @generated from message nova.playout.v1.StartFromSilence
 */
export type StartFromSilence = Message<"nova.playout.v1.StartFromSilence"> & {
};

/**
 * Describes the message nova.playout.v1.StartFromSilence.
 * Use `create(StartFromSilenceSchema)` to create a new message.
 */
export const StartFromSilenceSchema: GenMessage<StartFromSilence> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 38);

/**
 * Plan Auto DJ's own items again (its settings changed).
 *
 * @generated from message nova.playout.v1.Replan
 */
export type Replan = Message<"nova.playout.v1.Replan"> & {
};

/**
 * Describes the message nova.playout.v1.Replan.
 * Use `create(ReplanSchema)` to create a new message.
 */
export const ReplanSchema: GenMessage<Replan> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 39);

/**
 * The ICE servers presenters are reached through (the engine's rtc.config).
 *
 * @generated from message nova.playout.v1.IceServer
 */
export type IceServer = Message<"nova.playout.v1.IceServer"> & {
  /**
   * @generated from field: repeated string urls = 1;
   */
  urls: string[];

  /**
   * @generated from field: string username = 2;
   */
  username: string;

  /**
   * @generated from field: string credential = 3;
   */
  credential: string;
};

/**
 * Describes the message nova.playout.v1.IceServer.
 * Use `create(IceServerSchema)` to create a new message.
 */
export const IceServerSchema: GenMessage<IceServer> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 40);

/**
 * @generated from message nova.playout.v1.RtcConfig
 */
export type RtcConfig = Message<"nova.playout.v1.RtcConfig"> & {
  /**
   * @generated from field: repeated nova.playout.v1.IceServer ice_servers = 1;
   */
  iceServers: IceServer[];
};

/**
 * Describes the message nova.playout.v1.RtcConfig.
 * Use `create(RtcConfigSchema)` to create a new message.
 */
export const RtcConfigSchema: GenMessage<RtcConfig> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 41);

/**
 * A presenter's offer (rtc.offer): `peer` is their link id.
 *
 * @generated from message nova.playout.v1.RtcOffer
 */
export type RtcOffer = Message<"nova.playout.v1.RtcOffer"> & {
  /**
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: string sdp = 3;
   */
  sdp: string;
};

/**
 * Describes the message nova.playout.v1.RtcOffer.
 * Use `create(RtcOfferSchema)` to create a new message.
 */
export const RtcOfferSchema: GenMessage<RtcOffer> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 42);

/**
 * A presenter's ICE candidate, as the browser's RTCIceCandidateInit in JSON.
 *
 * @generated from message nova.playout.v1.RtcIce
 */
export type RtcIce = Message<"nova.playout.v1.RtcIce"> & {
  /**
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * @generated from field: string candidate = 2;
   */
  candidate: string;
};

/**
 * Describes the message nova.playout.v1.RtcIce.
 * Use `create(RtcIceSchema)` to create a new message.
 */
export const RtcIceSchema: GenMessage<RtcIce> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 43);

/**
 * End a presenter's audio: they hung up (empty reason), or the station ends it (a reason
 * goes back to them as rtc.close).
 *
 * @generated from message nova.playout.v1.RtcHangup
 */
export type RtcHangup = Message<"nova.playout.v1.RtcHangup"> & {
  /**
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * @generated from field: string reason = 2;
   */
  reason: string;
};

/**
 * Describes the message nova.playout.v1.RtcHangup.
 * Use `create(RtcHangupSchema)` to create a new message.
 */
export const RtcHangupSchema: GenMessage<RtcHangup> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 44);

/**
 * A presenter's controls (theirs, or the station's for them).
 *
 * @generated from message nova.playout.v1.SetPresenter
 */
export type SetPresenter = Message<"nova.playout.v1.SetPresenter"> & {
  /**
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * @generated from field: optional bool muted = 2;
   */
  muted?: boolean | undefined;

  /**
   * @generated from field: optional bool talkback = 3;
   */
  talkback?: boolean | undefined;

  /**
   * @generated from field: optional bool ducking = 4;
   */
  ducking?: boolean | undefined;

  /**
   * 0..4
   *
   * @generated from field: optional double gain = 5;
   */
  gain?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.SetPresenter.
 * Use `create(SetPresenterSchema)` to create a new message.
 */
export const SetPresenterSchema: GenMessage<SetPresenter> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 45);

/**
 * How fast the music dips while a live presenter ducks (Settings -> Radio; 250 ms).
 *
 * @generated from message nova.playout.v1.SetStudio
 */
export type SetStudio = Message<"nova.playout.v1.SetStudio"> & {
  /**
   * @generated from field: optional double duck_ms = 1;
   */
  duckMs?: number | undefined;
};

/**
 * Describes the message nova.playout.v1.SetStudio.
 * Use `create(SetStudioSchema)` to create a new message.
 */
export const SetStudioSchema: GenMessage<SetStudio> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 46);

/**
 * From the playout program.
 *
 * @generated from message nova.playout.v1.Event
 */
export type Event = Message<"nova.playout.v1.Event"> & {
  /**
   * @generated from oneof nova.playout.v1.Event.event
   */
  event: {
    /**
     * @generated from field: nova.playout.v1.State state = 1;
     */
    value: State;
    case: "state";
  } | {
    /**
     * @generated from field: nova.playout.v1.Meter meter = 2;
     */
    value: Meter;
    case: "meter";
  } | {
    /**
     * @generated from field: nova.playout.v1.Reply reply = 3;
     */
    value: Reply;
    case: "reply";
  } | {
    /**
     * @generated from field: nova.playout.v1.Outputs outputs = 4;
     */
    value: Outputs;
    case: "outputs";
  } | {
    /**
     * @generated from field: nova.playout.v1.Started started = 5;
     */
    value: Started;
    case: "started";
  } | {
    /**
     * Phase B and C.
     *
     * @generated from field: nova.playout.v1.Queue queue = 6;
     */
    value: Queue;
    case: "queue";
  } | {
    /**
     * @generated from field: nova.playout.v1.Played played = 7;
     */
    value: Played;
    case: "played";
  } | {
    /**
     * @generated from field: nova.playout.v1.Skipped skipped = 8;
     */
    value: Skipped;
    case: "skipped";
  } | {
    /**
     * @generated from field: nova.playout.v1.Inputs inputs = 9;
     */
    value: Inputs;
    case: "inputs";
  } | {
    /**
     * @generated from field: nova.playout.v1.Station station = 10;
     */
    value: Station;
    case: "station";
  } | {
    /**
     * @generated from field: nova.playout.v1.Notice notice = 11;
     */
    value: Notice;
    case: "notice";
  } | {
    /**
     * @generated from field: nova.playout.v1.Trimmed trimmed = 12;
     */
    value: Trimmed;
    case: "trimmed";
  } | {
    /**
     * Phase D.
     *
     * @generated from field: nova.playout.v1.RtcSignal rtc_signal = 13;
     */
    value: RtcSignal;
    case: "rtcSignal";
  } | {
    /**
     * @generated from field: nova.playout.v1.Presenters presenters = 14;
     */
    value: Presenters;
    case: "presenters";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message nova.playout.v1.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema: GenMessage<Event> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 47);

/**
 * For a presenter, to be relayed on the live link: the answer (rtc.answer), an ICE
 * candidate (rtc.ice), or the end of their audio (rtc.close, with why).
 *
 * @generated from message nova.playout.v1.RtcSignal
 */
export type RtcSignal = Message<"nova.playout.v1.RtcSignal"> & {
  /**
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * "answer", "ice" or "close"
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string sdp = 3;
   */
  sdp: string;

  /**
   * RTCIceCandidateInit in JSON
   *
   * @generated from field: string candidate = 4;
   */
  candidate: string;

  /**
   * @generated from field: string reason = 5;
   */
  reason: string;
};

/**
 * Describes the message nova.playout.v1.RtcSignal.
 * Use `create(RtcSignalSchema)` to create a new message.
 */
export const RtcSignalSchema: GenMessage<RtcSignal> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 48);

/**
 * The presenters connected, for every desk (the window's `presenters` message).
 *
 * @generated from message nova.playout.v1.Presenter
 */
export type Presenter = Message<"nova.playout.v1.Presenter"> & {
  /**
   * @generated from field: string peer = 1;
   */
  peer: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool connected = 3;
   */
  connected: boolean;

  /**
   * connected, unmuted and not on talkback: on air
   *
   * @generated from field: bool live = 4;
   */
  live: boolean;

  /**
   * @generated from field: bool muted = 5;
   */
  muted: boolean;

  /**
   * @generated from field: bool talkback = 6;
   */
  talkback: boolean;

  /**
   * @generated from field: bool ducking = 7;
   */
  ducking: boolean;

  /**
   * @generated from field: double gain = 8;
   */
  gain: number;

  /**
   * their voice, 0..1
   *
   * @generated from field: double level = 9;
   */
  level: number;

  /**
   * their return feed is on its way to them
   *
   * @generated from field: bool sending = 10;
   */
  sending: boolean;

  /**
   * how loud that return is as it leaves, 0..1
   *
   * @generated from field: double back = 11;
   */
  back: number;

  /**
   * why it is not, in words
   *
   * @generated from field: string problem = 12;
   */
  problem: string;
};

/**
 * Describes the message nova.playout.v1.Presenter.
 * Use `create(PresenterSchema)` to create a new message.
 */
export const PresenterSchema: GenMessage<Presenter> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 49);

/**
 * @generated from message nova.playout.v1.Presenters
 */
export type Presenters = Message<"nova.playout.v1.Presenters"> & {
  /**
   * @generated from field: repeated nova.playout.v1.Presenter list = 1;
   */
  list: Presenter[];
};

/**
 * Describes the message nova.playout.v1.Presenters.
 * Use `create(PresentersSchema)` to create a new message.
 */
export const PresentersSchema: GenMessage<Presenters> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 50);

/**
 * Where On air is. Sent on every change and, while playing, 10 times a second.
 *
 * @generated from message nova.playout.v1.State
 */
export type State = Message<"nova.playout.v1.State"> & {
  /**
   * -1: nothing current
   *
   * @generated from field: int32 index = 1;
   */
  index: number;

  /**
   * @generated from field: string current_key = 2;
   */
  currentKey: string;

  /**
   * @generated from field: bool playing = 3;
   */
  playing: boolean;

  /**
   * seconds into the current file
   *
   * @generated from field: double position = 4;
   */
  position: number;

  /**
   * @generated from field: double duration = 5;
   */
  duration: number;

  /**
   * @generated from field: double volume = 6;
   */
  volume: number;

  /**
   * @generated from field: double crossfade = 7;
   */
  crossfade: number;

  /**
   * @generated from field: bool levelling = 8;
   */
  levelling: boolean;

  /**
   * @generated from field: bool automation = 9;
   */
  automation: boolean;

  /**
   * the sound card in use, by name
   *
   * @generated from field: string output = 10;
   */
  output: string;

  /**
   * @generated from field: bool loading = 11;
   */
  loading: boolean;

  /**
   * empty: none
   *
   * @generated from field: string error = 12;
   */
  error: string;

  /**
   * when this was true (Unix ms), to carry the position forward
   *
   * @generated from field: uint64 at_ms = 13;
   */
  atMs: bigint;

  /**
   * the queue as the playout holds it, by key
   *
   * @generated from field: repeated string queue_keys = 14;
   */
  queueKeys: string[];

  /**
   * changes whenever the queue does (a Queue event carries it)
   *
   * @generated from field: uint64 queue_version = 15;
   */
  queueVersion: bigint;

  /**
   * @generated from field: bool ducked = 16;
   */
  ducked: boolean;

  /**
   * @generated from field: repeated nova.playout.v1.CartPlaying carts = 17;
   */
  carts: CartPlaying[];

  /**
   * @generated from field: nova.playout.v1.Mic mic = 18;
   */
  mic?: Mic | undefined;

  /**
   * the item a clip is playing over now; empty: none
   *
   * @generated from field: string over_key = 19;
   */
  overKey: string;
};

/**
 * Describes the message nova.playout.v1.State.
 * Use `create(StateSchema)` to create a new message.
 */
export const StateSchema: GenMessage<State> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 51);

/**
 * @generated from message nova.playout.v1.CartPlaying
 */
export type CartPlaying = Message<"nova.playout.v1.CartPlaying"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: string track_id = 2;
   */
  trackId: string;

  /**
   * seconds
   *
   * @generated from field: double length = 3;
   */
  length: number;

  /**
   * seconds into the file (this pass, for a loop)
   *
   * @generated from field: double position = 4;
   */
  position: number;
};

/**
 * Describes the message nova.playout.v1.CartPlaying.
 * Use `create(CartPlayingSchema)` to create a new message.
 */
export const CartPlayingSchema: GenMessage<CartPlaying> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 52);

/**
 * @generated from message nova.playout.v1.Mic
 */
export type Mic = Message<"nova.playout.v1.Mic"> & {
  /**
   * @generated from field: bool enabled = 1;
   */
  enabled: boolean;

  /**
   * @generated from field: bool live = 2;
   */
  live: boolean;

  /**
   * open and wired in
   *
   * @generated from field: bool ready = 3;
   */
  ready: boolean;

  /**
   * @generated from field: string error = 4;
   */
  error: string;

  /**
   * @generated from field: string device = 5;
   */
  device: string;
};

/**
 * Describes the message nova.playout.v1.Mic.
 * Use `create(MicSchema)` to create a new message.
 */
export const MicSchema: GenMessage<Mic> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 53);

/**
 * The whole queue, sent when it changes.
 *
 * @generated from message nova.playout.v1.Queue
 */
export type Queue = Message<"nova.playout.v1.Queue"> & {
  /**
   * @generated from field: uint64 version = 1;
   */
  version: bigint;

  /**
   * @generated from field: repeated nova.playout.v1.Item items = 2;
   */
  items: Item[];
};

/**
 * Describes the message nova.playout.v1.Queue.
 * Use `create(QueueSchema)` to create a new message.
 */
export const QueueSchema: GenMessage<Queue> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 54);

/**
 * Something finished sounding, for the play log.
 *
 * @generated from message nova.playout.v1.Played
 */
export type Played = Message<"nova.playout.v1.Played"> & {
  /**
   * @generated from field: string track_id = 1;
   */
  trackId: string;

  /**
   * @generated from field: uint64 started_ms = 2;
   */
  startedMs: bigint;

  /**
   * @generated from field: double seconds = 3;
   */
  seconds: number;

  /**
   * @generated from field: bool finished = 4;
   */
  finished: boolean;

  /**
   * "player", "cart", "over-song"
   *
   * @generated from field: string source = 5;
   */
  source: string;

  /**
   * @generated from field: string reason = 6;
   */
  reason: string;

  /**
   * @generated from field: string key = 7;
   */
  key: string;
};

/**
 * Describes the message nova.playout.v1.Played.
 * Use `create(PlayedSchema)` to create a new message.
 */
export const PlayedSchema: GenMessage<Played> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 55);

/**
 * A song that may not play was passed over.
 *
 * @generated from message nova.playout.v1.Skipped
 */
export type Skipped = Message<"nova.playout.v1.Skipped"> & {
  /**
   * @generated from field: string track_id = 1;
   */
  trackId: string;

  /**
   * @generated from field: string title = 2;
   */
  title: string;

  /**
   * @generated from field: string why = 3;
   */
  why: string;
};

/**
 * Describes the message nova.playout.v1.Skipped.
 * Use `create(SkippedSchema)` to create a new message.
 */
export const SkippedSchema: GenMessage<Skipped> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 56);

/**
 * @generated from message nova.playout.v1.Inputs
 */
export type Inputs = Message<"nova.playout.v1.Inputs"> & {
  /**
   * @generated from field: repeated nova.playout.v1.Output inputs = 1;
   */
  inputs: Output[];

  /**
   * @generated from field: string current = 2;
   */
  current: string;
};

/**
 * Describes the message nova.playout.v1.Inputs.
 * Use `create(InputsSchema)` to create a new message.
 */
export const InputsSchema: GenMessage<Inputs> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 57);

/**
 * Played items let go of (the playout keeps the last 50).
 *
 * @generated from message nova.playout.v1.Trimmed
 */
export type Trimmed = Message<"nova.playout.v1.Trimmed"> & {
  /**
   * @generated from field: repeated string keys = 1;
   */
  keys: string[];
};

/**
 * Describes the message nova.playout.v1.Trimmed.
 * Use `create(TrimmedSchema)` to create a new message.
 */
export const TrimmedSchema: GenMessage<Trimmed> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 58);

/**
 * For a person at a desk: something went wrong or needs them.
 *
 * @generated from message nova.playout.v1.Notice
 */
export type Notice = Message<"nova.playout.v1.Notice"> & {
  /**
   * @generated from field: string text = 1;
   */
  text: string;

  /**
   * @generated from field: bool bad = 2;
   */
  bad: boolean;
};

/**
 * Describes the message nova.playout.v1.Notice.
 * Use `create(NoticeSchema)` to create a new message.
 */
export const NoticeSchema: GenMessage<Notice> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 59);

/**
 * The station's brain (phase C): the modes, Auto DJ, fixed times, live shows.
 *
 * @generated from message nova.playout.v1.Station
 */
export type Station = Message<"nova.playout.v1.Station"> & {
  /**
   * the brain runs here (--station)
   *
   * @generated from field: bool running = 1;
   */
  running: boolean;

  /**
   * @generated from field: bool automation = 2;
   */
  automation: boolean;

  /**
   * @generated from field: bool auto_dj = 3;
   */
  autoDj: boolean;

  /**
   * @generated from field: string follow = 4;
   */
  follow: string;

  /**
   * what fills the slot, as of the last plan
   *
   * @generated from field: nova.playout.v1.Programme programme = 5;
   */
  programme?: Programme | undefined;

  /**
   * the live show that turned Automation off
   *
   * @generated from field: nova.playout.v1.LiveShow live = 6;
   */
  live?: LiveShow | undefined;

  /**
   * @generated from field: repeated nova.playout.v1.Marker markers = 7;
   */
  markers: Marker[];

  /**
   * @generated from field: double fade_seconds = 8;
   */
  fadeSeconds: number;

  /**
   * @generated from field: double late_limit = 9;
   */
  lateLimit: number;

  /**
   * markers whose content Auto DJ queued itself
   *
   * @generated from field: repeated string queued_early = 10;
   */
  queuedEarly: string[];

  /**
   * when each item began on air
   *
   * @generated from field: map<string, uint64> started_ms = 11;
   */
  startedMs: { [key: string]: bigint };
};

/**
 * Describes the message nova.playout.v1.Station.
 * Use `create(StationSchema)` to create a new message.
 */
export const StationSchema: GenMessage<Station> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 60);

/**
 * @generated from message nova.playout.v1.Programme
 */
export type Programme = Message<"nova.playout.v1.Programme"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * "playlist" or "flow"
   *
   * @generated from field: string kind = 2;
   */
  kind: string;

  /**
   * @generated from field: string start = 3;
   */
  start: string;

  /**
   * @generated from field: string end = 4;
   */
  end: string;
};

/**
 * Describes the message nova.playout.v1.Programme.
 * Use `create(ProgrammeSchema)` to create a new message.
 */
export const ProgrammeSchema: GenMessage<Programme> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 61);

/**
 * @generated from message nova.playout.v1.LiveShow
 */
export type LiveShow = Message<"nova.playout.v1.LiveShow"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string end = 2;
   */
  end: string;
};

/**
 * Describes the message nova.playout.v1.LiveShow.
 * Use `create(LiveShowSchema)` to create a new message.
 */
export const LiveShowSchema: GenMessage<LiveShow> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 62);

/**
 * A fixed time (markers/upcoming), as the engine gives it.
 *
 * @generated from message nova.playout.v1.Marker
 */
export type Marker = Message<"nova.playout.v1.Marker"> & {
  /**
   * a number, or "open:3" / "close:3"
   *
   * @generated from field: string marker_id = 1;
   */
  markerId: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * "hard" or "soft"
   *
   * @generated from field: string kind = 3;
   */
  kind: string;

  /**
   * local "YYYY-MM-DDTHH:MM"
   *
   * @generated from field: string at = 4;
   */
  at: string;

  /**
   * @generated from field: string align = 5;
   */
  align: string;

  /**
   * @generated from field: string start = 6;
   */
  start: string;

  /**
   * @generated from field: optional double content_seconds = 7;
   */
  contentSeconds?: number | undefined;

  /**
   * @generated from field: string content_kind = 8;
   */
  contentKind: string;

  /**
   * @generated from field: string content_ref = 9;
   */
  contentRef: string;
};

/**
 * Describes the message nova.playout.v1.Marker.
 * Use `create(MarkerSchema)` to create a new message.
 */
export const MarkerSchema: GenMessage<Marker> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 63);

/**
 * The output level, 20 times a second while anything sounds. 0..1, linear.
 *
 * @generated from message nova.playout.v1.Meter
 */
export type Meter = Message<"nova.playout.v1.Meter"> & {
  /**
   * @generated from field: float rms_left = 1;
   */
  rmsLeft: number;

  /**
   * @generated from field: float rms_right = 2;
   */
  rmsRight: number;

  /**
   * @generated from field: float peak_left = 3;
   */
  peakLeft: number;

  /**
   * @generated from field: float peak_right = 4;
   */
  peakRight: number;
};

/**
 * Describes the message nova.playout.v1.Meter.
 * Use `create(MeterSchema)` to create a new message.
 */
export const MeterSchema: GenMessage<Meter> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 64);

/**
 * @generated from message nova.playout.v1.Reply
 */
export type Reply = Message<"nova.playout.v1.Reply"> & {
  /**
   * @generated from field: uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: bool ok = 2;
   */
  ok: boolean;

  /**
   * @generated from field: string error = 3;
   */
  error: string;
};

/**
 * Describes the message nova.playout.v1.Reply.
 * Use `create(ReplySchema)` to create a new message.
 */
export const ReplySchema: GenMessage<Reply> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 65);

/**
 * @generated from message nova.playout.v1.Output
 */
export type Output = Message<"nova.playout.v1.Output"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: bool is_default = 3;
   */
  isDefault: boolean;
};

/**
 * Describes the message nova.playout.v1.Output.
 * Use `create(OutputSchema)` to create a new message.
 */
export const OutputSchema: GenMessage<Output> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 66);

/**
 * @generated from message nova.playout.v1.Outputs
 */
export type Outputs = Message<"nova.playout.v1.Outputs"> & {
  /**
   * @generated from field: repeated nova.playout.v1.Output outputs = 1;
   */
  outputs: Output[];

  /**
   * @generated from field: string current = 2;
   */
  current: string;
};

/**
 * Describes the message nova.playout.v1.Outputs.
 * Use `create(OutputsSchema)` to create a new message.
 */
export const OutputsSchema: GenMessage<Outputs> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 67);

/**
 * An item began to sound (for the play log): its key and when (Unix ms).
 *
 * @generated from message nova.playout.v1.Started
 */
export type Started = Message<"nova.playout.v1.Started"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: uint64 at_ms = 2;
   */
  atMs: bigint;
};

/**
 * Describes the message nova.playout.v1.Started.
 * Use `create(StartedSchema)` to create a new message.
 */
export const StartedSchema: GenMessage<Started> = /*@__PURE__*/
  messageDesc(file_nova_playout_v1_playout, 68);

/**
 * What a cart does to carts already playing as it fires, and to the song on air.
 *
 * @generated from enum nova.playout.v1.CartOthers
 */
export enum CartOthers {
  /**
   * the default: one cart at a time
   *
   * @generated from enum value: CART_OTHERS_STOP = 0;
   */
  STOP = 0,

  /**
   * @generated from enum value: CART_OTHERS_ALONGSIDE = 1;
   */
  ALONGSIDE = 1,

  /**
   * @generated from enum value: CART_OTHERS_DIP = 2;
   */
  DIP = 2,
}

/**
 * Describes the enum nova.playout.v1.CartOthers.
 */
export const CartOthersSchema: GenEnum<CartOthers> = /*@__PURE__*/
  enumDesc(file_nova_playout_v1_playout, 0);

/**
 * @generated from enum nova.playout.v1.CartMusic
 */
export enum CartMusic {
  /**
   * the default: over the music
   *
   * @generated from enum value: CART_MUSIC_OVER = 0;
   */
  OVER = 0,

  /**
   * @generated from enum value: CART_MUSIC_DIP = 1;
   */
  DIP = 1,

  /**
   * the song fades out; the next item waits for Play
   *
   * @generated from enum value: CART_MUSIC_TAKEOVER = 2;
   */
  TAKEOVER = 2,
}

/**
 * Describes the enum nova.playout.v1.CartMusic.
 */
export const CartMusicSchema: GenEnum<CartMusic> = /*@__PURE__*/
  enumDesc(file_nova_playout_v1_playout, 1);

